<div class="ap-margin-bottom-3">{{ 'income.income.field.text' | apContent }}</div>
<ap-income
    id="mainApplicantIncome"
    [incomeForm]="mainApplicantAnnualIncomeForm"
    [numberOfDecimals]="0"
    [showEntrepreneurIncome]="true"
    [contentKeyMap]="contentKeyMap"
    (calculateIncomeOpened)="sendAnalyticsCalculateIncome()"
>
</ap-income>

@if (!showCoApplicant) {
    <ap-icon-button-link
        id="toggleCoApplicant"
        iconName="plus-circle"
        (onClick)="setShowCoApplicant(true)"
        analyticsClick
        [key]="questionKey"
        elementType="TOGGLE_CO_APPLICANT_TRUE"
        >{{ 'income.income-co-applicant.info' | apContent }}</ap-icon-button-link
    >
}

@if (showCoApplicant) {
    <div class="ap-margin-bottom-3">
        <ap-action-icon
            id="removeCoApplicant"
            class="ap-margin-right-1"
            ariaLabel="Verwijder partner inkomen"
            (onClick)="setShowCoApplicant(false)"
            analyticsClick
            [key]="questionKey"
            elementType="TOGGLE_CO_APPLICANT_FALSE"
        >
            <ap-icon name="minus-circle" size="medium" color="secondary"></ap-icon>
        </ap-action-icon>
        {{ 'income.income-co-applicant.text' | apContent }}
    </div>
    <ap-income
        id="coApplicantIncome"
        [incomeForm]="coApplicantAnnualIncomeForm"
        [numberOfDecimals]="0"
        [showEntrepreneurIncome]="true"
        [contentKeyMap]="partnerContentKeyMap"
        (calculateIncomeOpened)="sendAnalyticsCalculateIncome()"
    ></ap-income>
}

<additional-info
    [key]="questionKey"
    id="hintGrossYearlyIncome"
    titleKey="income.additional-info.title"
    contentKey="income.additional-info.content"
    modalUrlKey="income.additional-info.url-text"
></additional-info>

@if (showButton()) {
    <next-button (click)="onClick()" [contentKey]="'global.continue-button.max-mortgage.text'"></next-button>
}
